<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn small icon v-bind="attrs" v-on="on" @click.stop>
        <v-icon small>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="$emit('detail')">
        <v-list-item-icon class="mr-2"><v-icon small>mdi-information-outline</v-icon></v-list-item-icon>
        <v-list-item-title>{{ $tt('customDetail') }}</v-list-item-title>
      </v-list-item>
      <v-list-item :disabled="!deletable" @click="$emit('remove')">
        <v-list-item-icon class="mr-2"><v-icon small color="error">mdi-trash-can-outline</v-icon></v-list-item-icon>
        <v-list-item-title class="error--text">{{ $tt('customDelete') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
/**
 * 圃場一覧の行末に置く縦3点メニュー (詳細/削除)。
 * deletable=false のときは削除を無効化する (他人の圃場)。
 */
export default {
  name: 'FieldRowMenuComponent',
  props: {
    field: { type: Object, required: true },
    deletable: { type: Boolean, default: true },
  },
}
</script>
